import React, { useEffect, useMemo, useState, useCallback, Fragment } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  withStyles,
  IconButton,
  Typography,
  withWidth,
  isWidthUp,
  Toolbar,
  Collapse,
  Divider,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const styles = theme => ({
  closeIcon: {
    marginRight: theme.spacing(0.5)
  },
  headSection: {
    width: "100vw",
  },
  blackList: {
    backgroundColor: theme.palette.background.default,
    height: "100%",
  },
  paperList: {
    backgroundColor: theme.palette.background.default,
    height: "100%",
    "& .MuiListItem-gutters": {
      paddingLeft: theme.spacing(4),
      "& .MuiListItemIcon-root": {
        minWidth: theme.spacing(2),
      },
    },
  },
  whiteList: {
    backgroundColor: theme.palette.common.white,
    height: "100%",
    "& .MuiListItem-gutters": {
      paddingLeft: theme.spacing(4),
      "& .MuiListItemIcon-root": {
        minWidth: theme.spacing(2),
      },
    },
  },
  noDecoration: {
    textDecoration: "none !important",
    color: theme.palette.common.black,
  },
  selected: {
    color: theme.palette.primary.main,
    borderLeftWidth: theme.spacing(0.5),
    borderStyle: "solid",
    backgroundColor: `${theme.palette.common.transparent} !important`,
  },
});

const MListItem = withStyles(styles, { withTheme: true })((props) => {
  const { classes, element, selectedItem, icon, ...rest } = props;
  return (
    <ListItem 
      button
      disableRipple
      disableTouchRipple
      selected={selectedItem === element.value}
      classes={{ selected: classes.selected }}
      {...rest}
    >
      {icon ? <ListItemIcon></ListItemIcon> : null}
      <ListItemText
        primary={
          <Typography variant="subtitle1" className="text-medium">
            {element.name}
          </Typography>
        }
      />
    </ListItem>
  );
});

// 修复移动端路由跳转
const CollapseList = withStyles(styles, { withTheme: true })((props) => {
  const { classes, selectedItem } = props;
  const { element, listStyle, icon, onClose } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const listView = useMemo(() => {
    const { list } = element;
    if (_.isArray(list) && list.length) {
      return _.map(list, (l) => {
        if (_.isArray(l.list) && l.list.length) {
          return (
            <CollapseList
              key={l.value}
              element={l}
              listStyle={classes.paperList}
              icon
              // add 
              onClose={onClose}
            />
          );
        }
        if (l.link) {
          return (
            <Link
              key={l.name}
              to={l.link}
              onClick={onClose}
              className={classes.noDecoration}
            >
              <MListItem
                element={l}
                selectedItem={selectedItem}
                icon={icon}
              />
            </Link>
          )
        }
        return (
          <MListItem
            key={l.value}
            element={l}
            selectedItem={selectedItem}
            icon={icon}
          />
        )
      });
    }
    return null;
  }, [element, selectedItem, icon, classes.paperList, classes.noDecoration,onClose]);

  return (
    <Fragment>
      <MListItem
        element={element}
        selectedItem={selectedItem}
        onClick={handleClick}
      />
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className={listStyle}>
          {listView}
        </List>
      </Collapse>
    </Fragment>
  );
});

function NavigationDrawer(props) {
  const { width, classes, theme } = props;
  const { open, onClose, anchor, menuItems, selectedItem } = props;

  useEffect(() => {
    window.onresize = () => {
      if (isWidthUp("sm", width) && open) {
        onClose();
      }
    };
  }, [width, open, onClose]);

  return (
    <Drawer variant="temporary" open={open} onClose={onClose} anchor={anchor}>
      <Toolbar className={classes.headSection}>
        <ListItem
          style={{
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(0),
            height: "100%",
            justifyContent: anchor === "left" ? "flex-start" : "flex-end",
          }}
          disableGutters
        >
          <ListItemIcon className={classes.closeIcon}>
            <IconButton onClick={onClose} aria-label="Close Navigation">
              <CloseIcon color="primary" />
            </IconButton>
          </ListItemIcon>
        </ListItem>
      </Toolbar>
      <Divider />
      <List className={classes.blackList}>
        {menuItems.map(element => {
          if (element.popup) {
            return (
              <CollapseList
                key={element.value}
                element={element}
                listStyle={classes.whiteList}
                onClose={onClose}
              />
            );
          }
          if (element.link) {
            return (
              <Link
                key={element.name}
                to={element.link}
                className={classes.noDecoration}
                onClick={onClose}
              >
                <MListItem 
                  key={element.value}
                  element={element}
                  selectedItem={selectedItem}
                />
              </Link>
            );
          }
          return (
            <MListItem 
              key={element.value}
              element={element}
              selectedItem={selectedItem}
              onClick={element.onClick}
            />
          );
        })}
      </List>
    </Drawer>
  );
}
NavigationDrawer.propTypes = {
  anchor: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  selectedItem: PropTypes.string
};

export default withWidth()(
  withStyles(styles, { withTheme: true })(NavigationDrawer)
);
